import React from "react";
import { GriddleComponents } from "griddle-react";

export const BasicLayout = (props: GriddleComponents) => (
    <div className="table-responsive">
        <props.Table />
    </div>
);
